var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-twitter" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.twitter.text-options")) +
                " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _c(
              "div",
              { staticClass: "type-switch" },
              [
                _vm._v(
                  "\n                 " +
                    _vm._s(
                      _vm.$t("dash.post-creator.form.twitter.split-text")
                    ) +
                    "\n                "
                ),
                _c("ComponentSwitch", {
                  attrs: {
                    value: _vm.draftInstance.form.networks.twitter
                      .tweetSplitting
                      ? _vm.draftInstance.form.networks.twitter.tweetSplitting
                          .active
                      : false,
                    onChange: _vm.handlerTweetSplitting,
                    id: "switch-settings-advanced-twitter-1",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm.draftInstance.form.urlsTextContentHistory.length &&
        this.textContentLength + 23 <= this.maxCharactersText
          ? _c("details", { attrs: { open: "" } }, [
              _c("summary", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("dash.post-creator.form.link-preview")) +
                    "\n            "
                ),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]),
              _c("div", { staticClass: "content-detail form-link" }, [
                _c(
                  "div",
                  { staticClass: "list-thubmmail" },
                  _vm._l(
                    this.draftInstance.form.urlsTextContentHistory,
                    function (url) {
                      return _c(
                        "div",
                        {
                          key: url.value,
                          staticClass: "thubmmail",
                          on: { click: () => _vm.selectUrl(url.value) },
                        },
                        [
                          _c("Checkbox", {
                            attrs: {
                              id: url.value,
                              prefixId: "thubmmail-",
                              isChecked:
                                _vm.draftInstance.form.networks.twitter.snippet
                                  .link == url.value,
                              isDisable:
                                _vm.draftInstance.form.networks.twitter.snippet
                                  .link == url.value,
                              add: _vm.selectUrl,
                              remove: () => {},
                            },
                          }),
                          _c("SnippetNetwork", { attrs: { link: url.value } }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }